import React from 'react';
import PureAlreadySetupView from './already-set-up';
import { useDispatch } from 'react-redux';
import { infoBoxDismissed, submitRequestPasswordReset } from 'phoenix2/state/new-user/actions';

export const AlreadySetUpView = () => {
    const dispatch = useDispatch();
    return (
        <PureAlreadySetupView
            onBackToLogin={() => dispatch(infoBoxDismissed())}
            onRequestPasswordReset={() => dispatch(submitRequestPasswordReset())}
        />
    );
};
